import React, { PropsWithChildren, useEffect, useState } from "react";

import { useGetInitialAppData } from "../../api/InitialAppData";
import { InitialAppDataContext } from "./InitialAppDataContext";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";
import { CountryCode } from "../../utils/CountryCode";
import DefaultLocationModal from "../Modal/DefaultLocationModal";

const InitialAppDataProvider: React.FC<PropsWithChildren<any>> = (props) => {
	const [{ data, loading }] = useGetInitialAppData();
	const [isDefaultLocationModalOpen, setIsDefaultLocationModalOpen] = useState<boolean>(false);
	const defaultInitialAppData = {
		locations: [],
		userInformation: {
			country: CountryCode.AU,
			roles: [],
			ipAddress: "",
			didDefaultCountry: false
		}
	}

	useEffect(() => {
		if (data) {
			setIsDefaultLocationModalOpen(data.userInformation.didDefaultCountry);
		}
	}, [data]);

	return (
		<>
			<LoadingIndicator open={loading} content="Application loading" />
			<DefaultLocationModal isOpen={isDefaultLocationModalOpen} onClose={() => setIsDefaultLocationModalOpen(false)}/>
			{!loading && (
				<InitialAppDataContext.Provider value={data ?? defaultInitialAppData}>{props.children}</InitialAppDataContext.Provider>
			)}
		</>
	);
};

export default InitialAppDataProvider;
